import { useFrame, useThree } from '@react-three/fiber';
import { RefObject } from 'react';
import { Group, Vector3 } from 'three';
import { Vector3OrArray } from '../../../types';

const o = new Vector3();

export default function useAlignLabel(labelRef: RefObject<Group>, sphereCenter: Vector3OrArray, sphereSize: number): void
{
  const { camera } = useThree();

  useFrame(() =>
  {
    if (!labelRef.current) return;
    const v = labelRef.current.position;
    if (Array.isArray(sphereCenter)) {
      v.fromArray(sphereCenter);
    }
    else {
      v.copy(sphereCenter);
    }

    o.setFromMatrixColumn(camera.matrixWorld, 1);

    // add the sphere itself, as well as the possible transition
    v.addScaledVector(o, sphereSize + 0.07);
  });
}